import { usePageStore } from "@voix/store/pageStore";
export default (voix) => {
  voix.fetch = async (url, options) => {
    const theOptions = options || {};
    if (!theOptions?.headers)
      theOptions.headers = new Headers();
    const pageStore = usePageStore();
    const xVoixSite = pageStore.currentPage?.site_id ? pageStore.currentPage.site_id.toString() : "0";
    theOptions.headers.append("x-voix-site", xVoixSite);
    return fetch(url, theOptions);
  };
  return voix;
};
